import { Color, DefaultValue, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'
import { transparentize } from 'polished'

export const MenuActionsWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${Spacing.S16};
`

export const IconButtonWrapper = styled.div`
  width: 130px;
`

export const DropdownContent = styled.ul`
  display: flex;
  flex-direction: column;
  width: 191px;
  padding: ${Spacing.S4};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${Color.White};
  box-shadow: 0 10px 15px ${transparentize(0.85, Color.Grey950)};
`
export const DropDownItem = styled.li`
  display: flex;
  align-items: center;
  gap: ${Spacing.S8};
  padding: ${Spacing.S8} ${Spacing.S16};
  &:hover {
    border-radius: ${DefaultValue.BorderRadius};
    background-color: ${Color.Grey200};
    cursor: pointer;
  }
`
